import Cookies from 'js-cookie'
const TokenKey = 'bdt'
const NameKey = 'user-nickname'
const PhoneKey = 'user-phone'

export function getName() {
  return Cookies.get(NameKey)
}
export function removeName() {
  return Cookies.remove(NameKey)
}
export function setName(name: string) {
  return Cookies.set(NameKey, name);
}
// 获取 token的方法
export function getToken() {
  return Cookies.get(TokenKey)
}

// 删除 token 的方法
export function removeToken() {
  return Cookies.remove(TokenKey)
}

// 设置 token 的方法
export function setToken(token: string) {
  return Cookies.set(TokenKey, token);
}


export function setPhone(phone: string) {
  if (!phone) {
    Cookies.remove(PhoneKey)
  } else {
    Cookies.set(PhoneKey, phone)
  }

}

export function getPhone() {
  return Cookies.get(TokenKey)
}


